import axios from "axios";
import { columnSequence } from "../../components/Stepper/StepZero/StepZero";
import * as types from "./app.actionTypes";
import { exportToXLSX, generateExcelFile } from "./utils";

/* ------- base url ----------*/
// export const baseUrl = "https://15.207.112.105.nip.io"; // dev backend
// export const baseUrl = "https://ocr.backend-ripik.com"; // prod backend
export const baseUrl = process.env.REACT_APP_BASE_URL;

export const editQtyToBeProduced = (value) => (dispatch) => {
  try {
    dispatch({ type: types.EDIT_INPUT_ORE_MATERIAL_SUM, payload: value });
    dispatch(inConsistancy());
  } catch (error) {
    console.error("Error in editBoundsAPI", error);
  }
};

export const editConstraintAPI = (item, type) => (dispatch) => {
  dispatch({ type: type, payload: item });
};

export const editBoundsAPI = (type, payload) => (dispatch) => {
  // console.log(type, payload);
  // dispatch({ type: type, payload: payload });
  try {
    // Your existing logic for the editBoundsAPI action
    // ...
    dispatch({ type: type, payload: payload });
    // After dispatching the action, call inConsistancy
    dispatch(inConsistancy());
  } catch (error) {
    // Handle errors if needed
    console.error("Error in editBoundsAPI", error);
  }
};

export const addFileAPI = (file) => (dispatch) => {
  dispatch({ type: types.ADD_FILE, payload: file });
};

export const uploadBurdenAPI = (payload) => {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  let raw = JSON.stringify(payload);
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  let upload_burden_url = `${baseUrl}/b1/history`;

  return fetch(upload_burden_url, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
};

export const optimizeBurdenMixAPI =
  (myState, fileData) => async (dispatch, getState) => {
    // console.log("fileData", fileData);
    const state = getState();
    // const { app } = state;
    // const { binStatus } = app;
    // const { postDataForApi } = binStatus;

    // let formdata = new FormData();
    // let inputFile = state.app.inputFile;
    // formdata.append("data", inputFile);

    // let { bounds } = state.app;
    // let { constraints, controllers, weightage_factors, assumptions } = bounds;

    // let all_seeds = {};

    // controllers.forEach((elem) => {
    //   if (elem.category === "TOP_CONTROLLERS") {
    //     formdata.append(elem.name, "" + Number(elem.value));
    //   } else {
    //     let { name, category, value } = elem;
    //     if (
    //       all_seeds[category] == undefined ||
    //       all_seeds[category] == "" ||
    //       all_seeds[category] == null
    //     ) {
    //       all_seeds[category] = { [name]: value };
    //     } else {
    //       all_seeds[category] = {
    //         ...all_seeds[category],
    //         [name]: value,
    //       };
    //     }
    //   }
    // });

    // formdata.append("all_seeds", JSON.stringify(all_seeds));

    // constraints.forEach((elem) => {
    //   formdata.append(elem.name, Number(elem.value));
    // });

    // weightage_factors.forEach((elem) => {
    //   formdata.append(elem.name, Number(elem.value));
    // });

    // let ash_analysis_assumption = {};

    // assumptions.forEach((elem) => {
    //   let { category } = elem;
    //   if (!category) {
    //     formdata.append(elem.name, Number(elem.value));
    //   } else {
    //     let { name, category, value } = elem;
    //     if (!ash_analysis_assumption[category]) {
    //       ash_analysis_assumption[category] = {
    //         [name]: value,
    //       };
    //     } else {
    //       ash_analysis_assumption[category] = {
    //         ...ash_analysis_assumption[category],
    //         [name]: value,
    //       };
    //     }
    //   }
    // });

    // formdata.append(
    //   "ash_analysis_assumption",
    //   JSON.stringify(ash_analysis_assumption)
    // );

    // formdata.append("Ore_qty_aim", state.app.input_ore_material_sum);
    let burden_mix_url = `${baseUrl}/b1/burden_mix`;
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: burden_mix_url,
      headers: {
        contentType: "application/json",
        "Client-Id": state.app.client_id,
      },
    };
    dispatch({ type: types.RESPONSE_LOADING });
    return axios
      .request(config)
      .then((response) => {
        let payload;

        if (typeof response.data === "string") {
          payload = JSON.parse(response.data.replace(/NaN/g, "null"));
        } else {
          payload = response.data;
        }

        console.log("responsedata", payload);
        console.log("response.data", typeof response.data);
        //update burden history start

        let historyObject = {
          // input: {
          //   file: fileData,
          //   bounds: bounds,
          //   input_ore_material_sum: state.app.input_ore_material_sum,
          // },
          output: payload,
          createdBy: state.auth.user,
          date: new Date(),
        };
        // handleDownload(historyObject);
        localStorage.setItem(
          "imfa_burden_mix_latest",
          JSON.stringify(historyObject)
        );
        // console.log({ historyObject });

        uploadBurdenAPI(historyObject).then((res) => {
          dispatch(getLatestBurdenAPI()).then((response) => {
            console.log("fetching the latest burden");
          });
        });

        //update burden history end

        return dispatch({
          type: types.RESPONSE_SUCCESS,
          payload: payload,
        });
      })
      .catch((error) => {
        console.log(error);
        return dispatch({ type: types.RESPONSE_FAILURE, payload: error });
      });
  };

export const resetErrorLoadingStatus = () => (dispatch) => {
  dispatch({ type: types.RESET_ERROR_LOADING_STATUS });
};

export const resetDefaultConstraints = () => (dispatch) => {
  dispatch({ type: types.RESET_DEFAULT_CONSTRAINT });
};

export const getLatestBurdenAPI = () => (dispatch) => {
  let latest_burden_url = `${baseUrl}/b1/history/latest`;
  dispatch({ type: types.RESPONSE_LOADING });
  return axios
    .get(latest_burden_url)
    .then((res) => {
      localStorage.setItem("imfa_burden_mix_latest", JSON.stringify(res.data));
      dispatch({ type: types.RESPONSE_SUCCESS, payload: res.data });
    })
    .catch((err) => dispatch({ type: types.RESPONSE_FAILURE }));
};

export const getHistoryAPI = () => (dispatch) => {
  let history_url = `${baseUrl}/b1/history`;
  dispatch({ type: types.GET_HISTORY_LOADING });
  axios
    .get(history_url)
    .then((res) => {
      dispatch({ type: types.GET_HISTORY_SUCCESS, payload: res.data });
    })
    .catch((err) => dispatch({ type: types.GET_HISTORY_FAILURE }));
};

export const createDeviationAPI = (payload) => (dispatch) => {
  dispatch({ type: types.CREATE_DEVIATION_LOADING });

  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  let raw = JSON.stringify(payload);
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  let create_deviation_url = `${baseUrl}/b1/deviation`;

  return fetch(create_deviation_url, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      // console.log("result for deviation creation pass", result);
      dispatch({ type: types.CREATE_DEVIATION_SUCCESS, payload: result });
    })
    .catch((error) => {
      // console.log(error);
      dispatch({ type: types.CREATE_DEVIATION_FAILURE });
    });
};

export const getDeviationAPI = () => (dispatch) => {
  let requestOptions = {
    method: "GET",
    redirect: "follow",
  };

  dispatch({ type: types.GET_DEVIATION_LOADING });

  let get_deviation_url = `${baseUrl}/b1/deviation`;

  return fetch(get_deviation_url, requestOptions)
    .then((res) => res.json())
    .then((res) => {
      // console.log("PAST DEVIATIONS", res);
      return dispatch({ type: types.GET_DEVIATION_SUCCESS, payload: res });
    })
    .catch((err) => {
      console.log(err);
      return dispatch({ type: types.GET_DEVIATION_FAILURE, payload: err });
    });
};

export const getConstraintsAPI = () => (dispatch) => {
  dispatch({ type: types.GET_CONSTRAINTS_LOADING });
  return axios
    .get(`${baseUrl}/b1/default`)
    .then((res) => {
      console.log("from get constraints : ", res.data[0]);
      return dispatch({
        type: types.GET_CONSTRAINTS_SUCCESS,
        payload: res.data[0],
      });
    })
    .catch((err) => {
      return dispatch({ type: types.GET_CONSTRAINTS_FAILURE, payload: err });
    });
};

export const updateConstraintsAPI = (id, bounds) => (dispatch) => {
  console.log("bound", bounds);
  if (!id) {
    console.log("NO ID FOUND : ", id, bounds);
    id = "649c059b7b1db53a47d1f241";
  }
  const url = `${baseUrl}/b1/default/${id}`;
  const data = JSON.stringify({ bounds: bounds });

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "PATCH",
    headers: myHeaders,
    body: data,
    redirect: "follow",
  };

  return fetch(url, requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.log("error", error));
};

export const ErpConverterAPI =
  (file, ash_analysis_assumption) => (dispatch) => {
    //this function taked the raw data file and converts into data ready file

    dispatch({ type: types.ERP_CONVERT_LOADING });

    const formdata = new FormData();
    formdata.append("data", file);
    formdata.append(
      "ash_analysis_assumption",
      JSON.stringify(ash_analysis_assumption)
    );

    // const formDataObject = {};
    // for (const pair of formdata.entries()) {
    //   formDataObject[pair[0]] = pair[1];
    // }

    // console.log("FormData as plain object:", formDataObject);

    const erp_url = `${baseUrl}/b1/format_raw_file`;

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: erp_url,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: formdata,
    };

    return axios
      .request(config)
      .then(async (response) => {
        console.log(response);
        // const data = JSON.stringify(response.d)
        // let data_ready_file = generateExcelFile(response.data, "data_ready.xlsx");
        const jsonData =
          typeof response.data === "string"
            ? JSON.parse(response.data.replace(/NaN/g, "null"))
            : response.data;
        // console.log(jsonData, "ok");
        const jsonDataForState =
          typeof response.data === "string"
            ? JSON.parse(
                response.data
                  .replace(/NaN/g, "null")
                  .replace(/""/g, "null")
                  .replace(/Cr\/Fe/g, "Cr\\/Fe")
                  .replace(/MgO\/Al2O3/g, "MgO\\/Al2O3")
              )
            : response.data;
        console.log(jsonDataForState, jsonData);
        dispatch(saveJsonData(jsonDataForState));

        // Get the keys in response.data
        const keys = Object.keys(jsonData);

        // Convert object to an array of objects
        const dataArray = [];

        // Assuming that all keys have the same length array
        for (let i = 0; i < Object.values(jsonData[keys[0]]).length; i++) {
          const newObj = {};
          keys.forEach((key) => {
            newObj[key] = jsonData[key][i];
          });
          dataArray.push(newObj);
        }
        // console.log(dataArray);
        // Generate Excel file with the array of objects
        let data_ready_file = await generateExcelFile(dataArray, "data_ready");
        exportToXLSX([...dataArray], columnSequence, "data_ready");

        return dispatch({
          type: types.ERP_CONVERT_SUCCESS,
          payload: data_ready_file,
        });
      })
      .catch((error) => {
        console.log(error);
        return dispatch({
          type: types.ERP_CONVERT_FAILURE,
          payload: error,
        });
      });
  };

export const updateErpRawFile = (file) => (dispatch) => {
  dispatch({ type: types.ERP_FILE_UPLOAD, payload: file });
};

export const transformControllersAPI = (dataReadyFile, steps) => (dispatch) => {
  dispatch({ type: types.TRANSFORM_CONTROLLERS_LOADING });
  var formdata = new FormData();
  formdata.append("constraints", JSON.stringify(steps));
  formdata.append("data", dataReadyFile, "file");

  console.log("dataReadyFile1", JSON.stringify(steps));
  const config = {
    method: "post",
    url: `${baseUrl}/b1/transform`,
    data: formdata,
    headers: {
      contentType: "multipart/form-data",
    },
  };

  return axios
    .request(config)
    .then(function (response) {
      return dispatch({
        type: types.TRANSFORM_CONTROLLERS_SUCCESS,
        payload: response.data,
      });
    })
    .catch(function (error) {
      return dispatch({
        type: types.TRANSFORM_CONTROLLERS_FAILURE,
        payload: error,
      });
    });
};

export const transformControllersAPI2 =
  (postDataForApi) => async (dispatch, getState) => {
    const state = getState();
    const { app } = state;
    const { binStatus } = app;
    const { postDataForApi } = binStatus;

    dispatch({ type: types.TRANSFORM_CONTROLLERS_LOADING });
    // var formdata = new FormData();
    // formdata.append("constraints", JSON.stringify(steps));
    // formdata.append("data", dataReadyFile, "file");

    // console.log("dataReadyFile1", JSON.stringify(steps));
    const postDataString = JSON.stringify(postDataForApi);
    const config = {
      method: "post",
      url: `${baseUrl}/b1/transform`,
      data: postDataForApi,
      headers: {
        contentType: "application/json",
      },
    };

    return axios
      .request(config)
      .then(function (response) {
        return dispatch({
          type: types.TRANSFORM_CONTROLLERS_SUCCESS,
          payload: response.data,
        });
      })
      .catch(function (error) {
        return dispatch({
          type: types.TRANSFORM_CONTROLLERS_FAILURE,
          payload: error,
        });
      });
  };

export const updateBinStatusData = (fileData) => (dispatch) => {
  dispatch({
    type: types.UPDATE_BIN_STATUS_DATA,
    payload: fileData,
  });
};

export const inConsistancy = () => async (dispatch, getState) => {
  try {
    const state = getState();

    let { bounds } = state.app;

    let { constraints, controllers, weightage_factors, assumptions, steps } =
      bounds;
    const { binStatus } = state.app;
    const { data, jsonData } = binStatus;
    const { input_ore_material_sum } = state.app;

    const transformedDataforBin = data.reduce((acc, item) => {
      const { idx, status, lotNumber } = item;
      const newItem = {};

      newItem.type = status.toLowerCase();
      newItem.lotno = lotNumber == null ? null : lotNumber.toString();

      acc[idx] = newItem;

      return acc;
    }, {});
    let ash_analysis_assumption = {};

    assumptions.forEach((elem) => {
      let { category } = elem;

      if (!category) {
        // formdata.append(elem.name, Number(elem.value));
      } else {
        let { name, category, value } = elem;
        if (!ash_analysis_assumption[category]) {
          ash_analysis_assumption[category] = {
            [name]: value,
          };
        } else {
          ash_analysis_assumption[category] = {
            ...ash_analysis_assumption[category],
            [name]: value,
          };
        }
      }
    });
    const postData = {
      constraints: [
        ...constraints,
        ...controllers,
        ...weightage_factors,
        ...assumptions,
        ...steps,

        { name: "Ore_qty_aim", value: 1000 },
        // { name: "CHIPS_STEP2", value: 60 },
        // { name: "LMG_LUMPS_STEP3", value: 60 },

        // { name: "LG_LUMPS_STEP3", value: 40 },
        // { name: "LMG_CHIPS_STEP3", value: 50 },
        // { name: "LG_CHIPS_STEP3", value: 55 },
        // { name: "HG_HMG_BQT_STEP3", value: 15 },
        // { name: "LG_LMG_BQT_STEP3", value: 45 },

        // { name: "HG_HMG_COMP_BQT_STEP3", value: 15 },
        // { name: "LG_LMG_COMP_BQT_STEP3", value: 0 },
        // { name: "Ore_qty_aim", value: 1000 },
        { name: "FC_balance_percent_aim", value: 100 },
      ].reduce((acc, constraint) => {
        acc[constraint.name] = constraint.value;
        return acc;
      }, {}),
      data: jsonData,
      bins_status: transformedDataforBin,
      ash_analysis_assumption: ash_analysis_assumption,
    };
    const postDataString = JSON.stringify(postData);
    dispatch(updatePostDataObj(postData));
    // Make the POST request
    const response = await axios.post(
      `${baseUrl}/b1/check_inconsistency`,
      postDataString,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log("POST request successful", response.request.status);
    dispatch(
      updateBinStatus({
        statusCode: response.request.status,
        jsonData: response.data,
      })
    );
    dispatch(transformControllersAPI2());
    // Dispatch any action or handle the response as needed
  } catch (error) {
    dispatch(updateBinStatuserror());
    console.error("Error making POST request", error);
    // Dispatch an action or handle the error as needed
  }
};

export const saveJsonData = (jsonData) => ({
  type: types.SAVE_JSON_DATA,
  payload: jsonData,
});

export const updateBinStatus = (newBinStatus) => ({
  type: types.UPDATE_BIN_STATUS,
  payload: newBinStatus,
});

export const updateBinStatuserror = () => ({
  type: types.UPDATE_BIN_STATUS_ERROR,
});

export const updatePostDataObj = (newBinStatus) => ({
  type: types.UPDATE_POST_DATA_OBJ,
  payload: newBinStatus,
});
